<template>
  <div class="tools-container">
    <div class="tools" :style="{ left, top }">
      <div class="tools-item zan active" v-if="hasGivenThumbUp">
        <button class="tools-box" title="取消点赞" @click="removeThumbUp">
          <div class="tools-zan__wrapper">
            <i class="yk-news_zan"></i>
          </div>
        </button>
        <div class="tools-item__num">{{ thumbUpTotal }}</div>
      </div>
      <div class="tools-item zan" v-else>
        <button class="tools-box" title="点赞" @click="addThumbUp">
          <div class="tools-zan__wrapper">
            <i class="yk-news_zan"></i>
          </div>
        </button>
        <div class="tools-item__num">{{ thumbUpTotal }}</div>
      </div>
      <div class="tools-item collection active" v-if="hasFavorite">
        <button class="tools-box" title="已收藏" @click="removeFavorite">
          <div>
            <i class="yk-news_favorite"></i>
          </div>
          <div class="tools-item__name">已收藏</div>
        </button>
      </div>
      <div class="tools-item collection" v-else>
        <button class="tools-box" title="收藏" @click="addFavorite">
          <div>
            <i class="yk-news_favorite"></i>
          </div>
          <div class="tools-item__name">收藏</div>
        </button>
      </div>
      <div class="tools-item">
        <el-popover placement="left-start" width="150px" trigger="hover" popper-class="share-popover">
          <button class="tools-box" title="分享" slot="reference">
            <div>
              <i class="yk-news_share"></i>
            </div>
            <div class="tools-item__name">分享</div>
          </button>
          <div>
            <canvas ref="qrCode"></canvas>
            <div class="tools-share__name">微信扫码分享</div>
          </div>
        </el-popover>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcode';
export default {
  name: 'PostTools',
  props: {
    // 新闻或专题详情
    post: Object,

    left: String,

    top: String,
  },
  data() {
    return {
      // 是否已点赞
      hasGivenThumbUp: false,
      // 点赞加载状态
      thumbLoading: false,
      // 收藏加载状态
      favoriteLoading: false,
    };
  },

  computed: {
    // 是否登录
    isLogin() {
      return this.$store.getters.isLogin;
    },
    // 点赞数
    thumbUpTotal() {
      return this.post.property.thumbUpTotal;
    },
    // 是否已收藏
    hasFavorite() {
      return this.post.property.isFavorite == true;
    },
  },
  mounted() {
    this.createQrcode();
  },
  methods: {
    /**
     * 生成二维码
     */
    createQrcode() {
      QRCode.toCanvas(this.$refs.qrCode, location.href, { width: 80, margin: 0 });
    },
    /**
     * 点赞
     */
    async addThumbUp() {
      if (this.thumbLoading) return;

      this.thumbLoading = true;
      await this.$axios
        .post('/cms/v1/give/thumb/up/to/post', {
          id: this.$route.params.id,
        })
        .finally(() => {
          this.thumbLoading = false;
        });
      this.hasGivenThumbUp = true;
      this.post.property.thumbUpTotal++;
      this.$success('点赞成功');
    },
    /**
     * 取消点赞
     */
    async removeThumbUp() {
      if (this.thumbLoading) return;

      this.thumbLoading = true;
      await this.$axios
        .post('/cms/v1/drop/thumb/up/to/post', {
          id: this.$route.params.id,
        })
        .finally(() => {
          this.thumbLoading = false;
        });
      this.hasGivenThumbUp = false;
      this.post.property.thumbUpTotal--;
      this.$success('取消点赞成功');
    },
    /**
     * 收藏
     */
    async addFavorite() {
      if (!this.isLogin) return this.$store.commit('showLoginDialog');

      if (this.favoriteLoading) return;

      this.favoriteLoading = true;
      await this.$axios
        .post('/cms/v1/add/favorite/item', {
          postId: this.$route.params.id,
        })
        .finally(() => {
          this.favoriteLoading = false;
        });
      this.post.property.isFavorite = true;
      this.$success('收藏成功');
    },
    /**
     * 取消收藏
     */
    async removeFavorite() {
      if (!this.isLogin) return this.$store.commit('showLoginDialog');

      if (this.favoriteLoading) return;

      this.favoriteLoading = true;
      await this.$axios
        .post('/cms/v1/remove/favorite/item', {
          postIds: [this.$route.params.id],
        })
        .finally(() => {
          this.favoriteLoading = false;
        });
      this.post.property.isFavorite = false;
      this.post.property.favorite -= 1;
      this.$success('取消收藏成功');
    },
  },
};
</script>
<style lang="scss" scoped>
.tools {
  position: fixed;
  z-index: 5;
}
.tools-item {
  margin-bottom: 20px;
  position: relative;
  text-align: center;
  &.zan {
    padding-bottom: 18px;
    &::after {
      content: '';
      width: 50%;
      height: 1px;
      background-color: #e7e7e7;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
    }
    .tools-zan__wrapper {
      background: #fff;
      color: var(--text-color-3);
    }
    &.active {
      .tools-zan__wrapper {
        background: rgba(228, 58, 58, 0.1);
        color: var(--primary-color);
      }
      .tools-item__num {
        color: var(--primary-color);
      }
    }
  }
  &.collection {
    &.active {
      color: var(--primary-color);
      .tools-item__name {
        color: inherit;
      }
    }
  }
  &:hover {
    opacity: 0.8;
  }
}
.tools-box {
  i {
    font-size: 20px;
  }
}
.tools-zan__wrapper {
  width: 48px;
  height: 48px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tools-item__num {
  font-size: 12px;
  line-height: 17px;
  color: var(--text-color-3);
  margin-top: 5px;
}
.tools-item__name {
  font-size: 12px;
  line-height: 17px;
  color: var(--text-color-3);
  margin-top: 2px;
}
.tools-share__logo {
  margin: auto;
}
.tools-share__name {
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-3);
  margin-top: 10px;
}
</style>
<style lang="scss">
.share-popover {
  box-sizing: border-box;
  text-align: center;
  padding: 20px 30px;
}
</style>
